import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { SelectedOrganisationId } from "../../_App/Redux/Slices/Auth/authSlice";
import {
  findBonsApi,
  Virements,
} from "../../_App/Redux/Slices/payments/PaymentSlice";
import Swal from "sweetalert2";
import VirementTable from "../../Components/Caisses/Payment/VirementTable";
import BonsTables from "../../Components/Caisses/Payment/BonsTables";

const BonsPAge = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const currentOrg = useAppSelector(SelectedOrganisationId);
  const cheques = useAppSelector(Virements);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (currentOrg) {
      dispatch(findBonsApi(currentOrg));
    }
  }, [dispatch]);

  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };

  return (
    <div>

      {cheques && cheques.length !== 0 ? <BonsTables /> : <p>aucun virement</p>}
    </div>
  );
};

export default BonsPAge;
